import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import InputSelect from '../../../../components/library/inputSelect';
import { fetchHousingTypes } from '../../../../../actions/lookupActions';

function HousingTypeSelect(props) {
  const dispatch = useDispatch();
  const housingTypes = useSelector(state => state.lookup.allHousingTypes);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    if (!housingTypes.housingTypes) {
      dispatch(fetchHousingTypes());
    } else {
      setOptions(
        housingTypes.housingTypes.map(item => {
          return { label: item.attributes.name, value: item.id };
        }),
      );
    }
  }, [housingTypes]);

  return (
    <>
      {housingTypes && housingTypes.housingTypes && (
        <InputSelect {...props} options={options} />
      )}
    </>
  );
}

HousingTypeSelect.propTypes = {
  errorMessage: propTypes.string,
  labelText: propTypes.string,
  helpText: propTypes.string,
  placeholder: propTypes.string,
  isRequired: propTypes.bool,
};


HousingTypeSelect.defaultProps = {
  errorMessage: '',
  labelText: 'HOUSING TYPE',
  helpText: '',
  placeholder: '',
  isRequired: false,
};

export default (HousingTypeSelect);
